<fieldset [formGroup]="parentFormGroup">
  <legend>
    <div>
      <span i18n>Bundle</span>
      <div>
        <eas-editor-booking-item-inheritable-type-badge *ngIf="itemBundleForm.value.length > 0" [inheritableType]="'set'">
        </eas-editor-booking-item-inheritable-type-badge>
        <button *ngIf="isDeletable()"
          mat-icon-button
          aria-label="Delete bundle"
          i18n-aria-label
          (click)="onDelete()">
          <mat-icon inline>delete</mat-icon>
        </button>
      </div>
    </div>
  </legend>
  <p i18n>
    This allows you to select other bookable options from the same level in the hierarchy.
    <br>
    Users booked onto the current option will also be booked onto the options selected here.
  </p>
  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label i18n>Select options to form this bundle</mat-label>
      <mat-select id="bundle" multiple formControlName="bundle">
        <mat-option *ngFor="let option of availableBundleNames" [value]="option.id" [title]="option.name">
          {{ option.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</fieldset>
